module.exports = "/assets/data/2331fc2c8cca5e1546fff0dba4ae435a-ME1.data.json";